import React from "react";
import { IconBaseProps } from "react-icons";

type Item = {
  path: string;
  link: {
    Icon: React.ComponentType<IconBaseProps>;
    title: string;
    color: string;
  };
  component: React.ComponentType;
};

export type Link = Omit<Item, "component">;
export type Route = Omit<Item, "link">;

type Init = {
  links: Array<Link>;
  routes: Array<Route>;
};

export function createLinksAndRoutes(list: Array<Item>) {
  return list.reduce<Init>(
    ({ links, routes }, { path, link, component }) => ({
      links: [...links, { path, link } ],
      routes: [...routes, { path, component }],
    }),
    { links: [], routes: [] }
  );
}
